module.exports = __webpack_public_path__ + "static/media/dark-blue-wave.9962a259.svg";